import { defineEntityContract, type EntityStateEvents, type QueuedChangeFailureEvents } from 'shared/channels/entity';
import type {
  OrganizationCreateRequest,
  OrganizationEditRequest,
} from 'shared/domain/messages/organization/eventMessages';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { OrganizationModel } from './types/model';

/** Organization events. A created or edited organization comes as the model the worker stored. */
export type OrganizationEvents = EntityStateEvents & QueuedChangeFailureEvents & {
  [DomainMessagesTypes.allOrganizations]: { hasAll?: boolean; items: OrganizationModel[] };
  [DomainMessagesTypes.createdEntity]: OrganizationModel;
  [DomainMessagesTypes.updatedEntity]: OrganizationModel;
};

export interface OrganizationLogoAddress {
  organizationId: string;
  logoId: string;
}

/**
 * Organization changes: each resolves once queued, its outcome follows as an
 * event with its `uniqueId`. A logo's signed URL is read from the server.
 */
export type OrganizationRequests = {
  create: { request: OrganizationCreateRequest; response: void };
  edit: { request: OrganizationEditRequest; response: void };
  getLogoSignedUrl: { request: OrganizationLogoAddress; response: string };
};

export const organizationContract = defineEntityContract<OrganizationModel, OrganizationEvents, OrganizationRequests>(
  'organizationChannel',
  { collectionEvent: DomainMessagesTypes.allOrganizations }
);
